// src/components/MetadataBrowser.jsx
import React from "react";
import MarkdownDoc from "./MarkdownDoc";


function MetadataBrowser({
  datasets,
  selectedDatasetId,
  setSelectedDatasetId,
  getAccessTokenSilently,
}) {
  const selected = datasets.find(
    (dataset) => dataset.id === selectedDatasetId
  );

  return (
    <div className="metadata-layout">
      <aside className="metadata-sidebar">
        <h4>Datasets</h4>

        {datasets.length === 0 ? (
          <p className="no-datasets">
            You do not have any datasets available.
          </p>
        ) : (
          <ul className="metadata-list">
            {datasets.map((dataset) => (
              <li key={dataset.id}>
                <button
                  className={
                    `metadata-link ` +
                    `${selectedDatasetId === dataset.id ? "active" : ""}`
                  }
                  onClick={() => setSelectedDatasetId(dataset.id)}
                >
                  {dataset.label}
                </button>
              </li>
            ))}
          </ul>
        )}
      </aside>

      <section className="metadata-content">
        {selected ? (
          <MarkdownDoc
            datasetId={selected.documentationId}
            getAccessTokenSilently={getAccessTokenSilently}
          />
        ) : (
          <p>
            {datasets.length
              ? "Select a dataset to view its metadata."
              : "No datasets to display."}
          </p>
        )}
      </section>
    </div>
  );
}

export default MetadataBrowser;